import React, { Component } from "react";
import { connect } from "react-redux";
import {Field} from "redux-form";

import Input from "../Input";
import Button from "../Button";
import SmsAuthSetup from "../SmsAuthSetup";
import AppSetup from "../AppSetup";

import styles from './styles.scss';

import * as accountActions from "../../../actions/account";


class AuthenticationMethods extends Component {
    constructor(props) {
        super(props);

        this.state = {
            primaryAuthMethod : {}
        };
    }

    componentDidMount() {
        this.setState({
            primaryAuthMethod: this.props.userAccount.auth_methods.find(authMethod => authMethod.is_primary).method
        });

        this.props.toggleAuthMethodSetup('');
    }

    _updateRadio(e){
        this.setState({
            primaryAuthMethod: e.target.value
        })
    }

    _onClickSetup(authMethod) {
        this.props.toggleAuthMethodSetup(authMethod);
    }

    _completeSetup() {
        this.props.toggleAuthMethodSetup(false);
        this.props.onSetupSuccess();
    }


    render() {
        if (!this.props.show) return null;

        const { userAccount } = this.props;

        return (
            <div>
                <p>A second step after entering your password verifies that it’s you signing in.</p>
                {userAccount.auth_methods && userAccount.auth_methods.length > 0 &&
                <div onChange={this._updateRadio.bind(this)}>
                    <div className={styles.authContainer}>
                        <h2>Email</h2>
                        <p>
                            A 6-digit code will be sent to your registered email address in order to validate your
                            login. The code will only be sent to the email that you use to login to our services.
                        </p>
                        <div className={styles.authSelect}>
                        <span className={styles.primaryRadio}>
                            <Field
                                component={Input}
                                type="radio"
                                name="primary_auth_method"
                                label="Select as primary method"
                                value="email"
                                id="primary_2fa_email"
                                checked={this.state.primaryAuthMethod === 'email'}
                                disabled={!userAccount.auth_methods.find(authMethod => authMethod.method === 'email')}
                            />
                        </span>
                        </div>
                    </div>
                    <div className={styles.authContainer}>
                        <h2>Google Authenticator App</h2>
                        <p>
                            In order to use app authentication, you will need to download the Google Authentication app to your smart phone or tablet device.
                        </p>
                        <p>
                            <a target="_blank"
                               href="https://apps.apple.com/gb/app/google-authenticator/id388497605"
                               className={styles['app-button']}>
                                <span>Download for iPhone</span>
                            </a>
                            <a target="_blank"
                               href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                               className={styles['app-button']}>
                                <span>Download for Android</span>
                            </a>
                        </p>
                        <p>
                            This app will periodically generate 6-digit codes for you to use when logging in to each service.
                        </p>
                        <div className={styles.authSelect}>
                            <Button disabled={this.props.authMethodSetupShowing === 'app'} type="button"
                                    onClick={this._onClickSetup.bind(this, 'app')}>
                                {userAccount.auth_methods.find(authMethod => authMethod.method === 'app') ? 'Reset App' : 'Setup'}
                            </Button>
                            <span className={styles.primaryRadio}>
                            <Field
                                component={Input}
                                type="radio"
                                name="primary_auth_method"
                                label="Select as primary method"
                                value="app"
                                id="primary_2fa_app"
                                checked={this.state.primaryAuthMethod === 'app'}
                                disabled={!userAccount.auth_methods.find(authMethod => authMethod.method === 'app')}
                            />
                            </span>
                        </div>
                        {this.props.authMethodSetupShowing === 'app' && (
                            <AppSetup
                                onCompleteSetup={() => this._completeSetup()}
                                userId={userAccount.id}
                                show={true}
                                onClickClose={this._onClickSetup.bind(this, false)}
                            />
                        )}
                    </div>
                    {/* Below is the SMS section of the 2FA setup. Please do not delete this. */}
                    {/*<div className={styles.authContainer}>*/}
                    {/*    <h2>SMS Message</h2>*/}
                    {/*    <p>*/}
                    {/*        A 6-digit code will be sent to your mobile number in order to validate your login. This method requires you to confirm your mobile number.*/}
                    {/*    </p>*/}
                    {/*    <div className={styles.authSelect}>*/}
                    {/*        <Button*/}
                    {/*            type="button"*/}
                    {/*            onClick={this._onClickSetup.bind(this, 'sms')}*/}
                    {/*            disabled={this.props.authMethodSetupShowing === 'sms'}*/}
                    {/*        >*/}
                    {/*            {userAccount.auth_methods.find(authMethod => authMethod.method === 'sms') ? 'Edit' : 'Setup'}*/}
                    {/*        </Button>*/}
                    {/*        <span className={styles.primaryRadio}>*/}
                    {/*            <Field*/}
                    {/*                component={Input}*/}
                    {/*                type="radio"*/}
                    {/*                name="primary_auth_method"*/}
                    {/*                label="Select as primary method"*/}
                    {/*                value="sms"*/}
                    {/*                id="primary_2fa_sms"*/}
                    {/*                checked={this.state.primaryAuthMethod === 'sms'}*/}
                    {/*                disabled={!userAccount.auth_methods.find(authMethod => authMethod.method === 'sms')}*/}
                    {/*            />*/}
                    {/*        </span>*/}
                    {/*    </div>*/}
                    {/*    {this.props.authMethodSetupShowing === 'sms' &&*/}
                    {/*        <SmsAuthSetup*/}
                    {/*            toggleShowSmsSetup={this._onClickSetup.bind(this, '')}*/}
                    {/*            telephone={userAccount.telephone}*/}
                    {/*            telephoneAuth={userAccount.telephone_auth}*/}
                    {/*            completeSetup={() => this._completeSetup()}*/}
                    {/*        />*/}
                    {/*    }*/}
                    {/*</div>*/}
                </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.account
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleAuthMethodSetup(method) {
            return dispatch(accountActions.toggleAuthMethodSetup(method));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationMethods);